import { createReducer, on } from '@ngrx/store';

import { HemsActions } from './hems.actions';
import { HemsState } from './hems.state';

export const initHemsState: HemsState = {
  gatewaySerial: null,
};

export const hemsReducer = createReducer(
  initHemsState,

  on(
    HemsActions.setHemsGatewaySerial,
    (state, { gatewaySerial }): HemsState => ({
      ...state,
      gatewaySerial,
    })
  )
);
